document.addEventListener('DOMContentLoaded', function () {
  var widget = document.createElement('div');
  widget.className = 'fsb-widget';
  widget.id = 'fsb-widget';
  widget.innerHTML = '<span class="fsb-icon">🚚</span><span id="fsb-text"></span>';
  document.body.appendChild(widget);

  var textEl = document.getElementById('fsb-text');

  function updateWidget() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          widget.classList.remove('fsb-visible');
          return;
        }

        widget.classList.add('fsb-visible');

        if (cart.item_count >= 2) {
          widget.classList.add('fsb-complete');
          textEl.textContent = 'Máš dopravu zdarma!';
        } else {
          widget.classList.remove('fsb-complete');
          textEl.textContent = 'Přidej ještě 1 kus a získej dopravu zdarma';
        }
      })
      .catch(function () {});
  }

  updateWidget();

  // Aktualizuj při každé změně košíku (přidání/odebrání položky)
  document.addEventListener('submit', function (e) {
    if (e.target.action && e.target.action.includes('/cart/add')) {
      setTimeout(updateWidget, 500);
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quantity-change], .quantity__button, [name="updates[]"]')) {
      setTimeout(updateWidget, 500);
    }
  });

  // Obnov i při návratu na stránku (např. po odebrání položky v košíku)
  window.addEventListener('pageshow', updateWidget);
});